
import React from 'react'


function Header() {
  return (
    <div>
      <div className="container-fluid bg-dark text-light p-0" style={{ "font-size": "0.8em", "fontWeight": "bold" }}>
        <div className="row gx-0 d-none d-lg-flex">
          <div className="col-lg-7 px-4 text-start">
            <div className="h-100 d-inline-flex align-items-center me-4">
              <small className="fa fa-map-marker-alt text-primary me-2" />
              <small>Mumbai, Maharashtra. India</small>
            </div>
            {/* <div className="h-100 d-inline-flex align-items-center me-2">
                <small className="far fa-clock text-primary me-2" />
                <small>Mon - Fri : 10.00 AM - 06.00 PM IST</small>
              </div>   */}
            {/* <div className="h-100 d-inline-flex align-items-center me-2">
              <small className="far fa-envelope text-primary me-2" />
              <small>anza.soft.tech@gmail.com</small>
            </div> */}
          </div>
          <div className="col-lg-5 px-5 text-end">
            {/* <div className="h-100 d-inline-flex align-items-center me-4">
              <small className="fa fa-phone-alt text-primary me-2" />
              <small></small>
            </div> */}
            {/* <div className="h-100 d-inline-flex align-items-center me-2 mx-n2">
                <a target="_blank" className="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href="https://www.facebook.com/profile.php?id=100085786775850"><i className="fab fa-facebook-f" /></a>
                <a target="_blank" className="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href="https://t.me/Stharis"><i className="fab fa-telegram" /></a>
                <a target="_blank" className="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href="https://www.youtube.com/user/stharishighschool"><i className="fab fa-youtube" /></a>
                <a target="_blank" className="btn btn-square btn-link rounded-0 border-0 border-end border-secondary" href="https://www.instagram.com/stharishighschool/"><i className="fab fa-instagram" /></a>
              </div> */}
          </div>
        </div>
      </div>

      {/* >>>>>>>>>> */}
      {/* <nav className="navbar navbar-expand-lg bg-white px-3"> */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white px-3">
        <div className="container-fluid">

          {/* LEFT: Logo + Company Name */}
          <a href="/" className="navbar-brand d-flex align-items-center ms-lg-5">
            <img
              src="/assets/img/Anza/logo5.png"
              width="80"
              height="80"
              className="logo-rounded me-2"
              alt="logo"
            />
            <div className="logo-text">
              <h4 className="fw-bold mb-0">ANZA</h4>
              <div>SOFTWARE</div>
              <div>TECHNOLOGIES</div>
            </div>
          </a>

          {/* MOBILE TOGGLER */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* RIGHT: MENU */}
          <div className="collapse navbar-collapse" id="mainNavbar">
            <div className="navbar-nav ms-auto">
              <a className="nav-link normal-case" href="/">Home</a>
              <a className="nav-link normal-case" href="/about">About Us</a>
              <a className="nav-link normal-case" href="/school">eSchool ERP</a>
              <a className="nav-link normal-case" href="/habitech">HabiTech</a>
              <a className="nav-link normal-case" href="/careerpage">Career</a>
              <a className="nav-link normal-case" href="/contact">Contact Us</a>
              <a className="nav-link btn btn-outline-primary ms-2 normal-case" href="/bookademo">
                Book a Demo
              </a>
            </div>
          </div>

        </div>
      </nav>

    </div>

  )
}

export default Header

      // <div className="container-fluid bg-white p-2">
      //   <div className="d-flex align-items-center" style={{ marginLeft: "5%" }}>

      //     {/* Logo */}
      //     <a href="/" className="me-2">
      //       <img
      //         src="/assets/img/Anza/logo5.png"
      //         width="80"
      //         height="80"
      //         className="logo-rounded"
      //         alt="logo"
      //       />
      //     </a>

      //     {/* Text */}
      //     <div className="logo-text">
      //       <h4 className="fw-bold mb-0">ANZA</h4>
      //       <div>SOFTWARE</div>
      //       <div>TECHNOLOGIES</div>
      //     </div>
      //   </div>
      // </div>
